import { IWidgetSettings } from '@/models/Widget/settings';
import APIService from '../api';
export default class MerchantService extends APIService {
  listProviders(data?: any) {
    return this.get('/merchant-connect/providers', data);
  }

  listConnectedProviders() {
    return this.get('/merchant-connect/oauth');
  }

  shouldUpdate(oauthId: string) {
    return this.get(`/merchant-connect/oauth/${oauthId}/update-scope`);
  }

  updateScopes(oauthId: string) {
    return this.put(`/merchant-connect/oauth/${oauthId}/update-scope`);
  }

  signupConnectBusiness(body: {
    oauthToken: string;
    businessId: string;
    type: string;
  }) {
    return this.post('/merchant-connect/business/connect', body);
  }

  connect(
    link: { url: string; method: 'GET' | 'POST' },
    params: string | Object = ''
  ) {
    if (link.method === 'GET') {
      return this.get(`${link.url}?${params}&json=true`);
    }

    if (link.method === 'POST') {
      return this.post(link.url, params as object);
    }
  }

  disconnect(link: { url: string; method: string }) {
    if (link.method === 'DELETE') {
      return this.delete(link.url);
    }
  }

  getBusinessSignup(token: string) {
    return this.get(`/merchant-connect/oauth/data?jwt=${token}`);
  }

  finishConnect(providerId: string) {
    return this.post(`/merchant-connect/oauth/finish`, { providerId });
  }

  getConnectSettings(oauthId: string) {
    return this.get(`/merchant-connect/oauth/${oauthId}/settings`);
  }

  setConnectSettings(oauthId: string, value: IWidgetSettings) {
    return this.put(`/merchant-connect/oauth/${oauthId}/settings`, value);
  }
}

export interface oauthProviderData {
  providerType: string;
  providerId: string;
}
